<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped lang="scss">
    div > * {
        margin-right: 10px;

        &:last-child {
            margin-right: 0;
        }
    }
</style>
